export enum DisparityCalculationStatus {
  PENDING = -1,
  IN_PROGRESS = -2,
  COMPLETED = -3,
  FAILED = -4,
}
